import axiosInstance from '../config/axios';

// ──────────────────────────────────────────────
// Marketplace APIs
// ──────────────────────────────────────────────

/**
 * Fetch all courses
 */
export const getCourses = (params = {}) =>
  axiosInstance.get('/course/list', { params }).then((res) => res.data);

/**
 * Fetch course categories
 */
export const getCourseCategoriesApi = () =>
  axiosInstance.get('/course-categories').then((res) => res.data);

/**
 * Fetch recommended courses
 */
export const getRecommended = () =>
  axiosInstance.get('/recommended').then((res) => res.data);

/**
 * Fetch trending courses
 */
export const getTrending = () =>
  axiosInstance.get('/trending').then((res) => res.data);

/**
 * Fetch course details by ID
 * @param {string} id
 */
export const getCourseById = (id) =>
  axiosInstance.get(`/course/detail/${id}`).then((res) => res.data);

/**
 * Fetch all lessons of a course
 * @param {string} courseId
 */
export const getAllCourseLessons = (courseId) =>
  axiosInstance.get('/get-all-course-lesson', { params: { courseId } }).then((res) => res.data);

/**
 * Create a new course
 * @param {object} data
 */
export const createCourseApi = (data) =>
  axiosInstance.post('/course/create', data).then((res) => res.data);

/**
 * Update a course
 * @param {string} id
 * @param {object} data
 */
export const updateCourseApi = (id, data) =>
  axiosInstance.put(`/course/update/${id}`, data).then((res) => res.data);

/**
 * Delete a course
 * @param {string} id
 */
export const deleteCourseApi = (id) =>
  axiosInstance.delete(`/course/delete/${id}`).then((res) => res.data);

/**
 * Add a review to a course
 * @param {object} data - { course_id, rating, review }
 */
export const addCourseReviewApi = (data) =>
  axiosInstance.post('/add-review', data).then((res) => res.data);

/**
 * Get reviews for a course
 * @param {string} courseId
 */
export const getCourseReviewsApi = (courseId) =>
  axiosInstance.get('/reviews', { params: { courseId } }).then((res) => res.data);
